import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateCheckboxFormField(
  params: FormFieldGenerationParams<'checkbox'>,
): PartialPropsOf<'checkbox'> {
  let props: PartialPropsOf<'checkbox'> = applyPropsPatch(params.props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, { content: { checkbox: { readonly: true } } });
  }
  return props;
}
